// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/user_telegram.proto (package tickettally.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/user_telegram.proto.
 */
export const file_v1_user_telegram: GenFile = /*@__PURE__*/
  fileDesc("ChZ2MS91c2VyX3RlbGVncmFtLnByb3RvEg50aWNrZXR0YWxseS52MSIeChxHZW5lcmF0ZVVzZXJMaW5rVG9rZW5SZXF1ZXN0Im8KHUdlbmVyYXRlVXNlckxpbmtUb2tlblJlc3BvbnNlEg8KB2NvbW1hbmQYASABKAkSDQoFdG9rZW4YAiABKAkSLgoKZXhwaXJlc19hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiHgocR2V0VXNlclRlbGVncmFtU3RhdHVzUmVxdWVzdCKRAQodR2V0VXNlclRlbGVncmFtU3RhdHVzUmVzcG9uc2USEQoJaXNfbGlua2VkGAEgASgIEhkKEXRlbGVncmFtX3VzZXJuYW1lGAIgASgJEhMKC3RlbGVncmFtX2lkGAMgASgDEi0KCWxpbmtlZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiGgoYVW5saW5rVXNlckFjY291bnRSZXF1ZXN0Ij0KGVVubGlua1VzZXJBY2NvdW50UmVzcG9uc2USDwoHc3VjY2VzcxgBIAEoCBIPCgdtZXNzYWdlGAIgASgJMusCChNVc2VyVGVsZWdyYW1TZXJ2aWNlEnQKFUdlbmVyYXRlVXNlckxpbmtUb2tlbhIsLnRpY2tldHRhbGx5LnYxLkdlbmVyYXRlVXNlckxpbmtUb2tlblJlcXVlc3QaLS50aWNrZXR0YWxseS52MS5HZW5lcmF0ZVVzZXJMaW5rVG9rZW5SZXNwb25zZRJ0ChVHZXRVc2VyVGVsZWdyYW1TdGF0dXMSLC50aWNrZXR0YWxseS52MS5HZXRVc2VyVGVsZWdyYW1TdGF0dXNSZXF1ZXN0Gi0udGlja2V0dGFsbHkudjEuR2V0VXNlclRlbGVncmFtU3RhdHVzUmVzcG9uc2USaAoRVW5saW5rVXNlckFjY291bnQSKC50aWNrZXR0YWxseS52MS5VbmxpbmtVc2VyQWNjb3VudFJlcXVlc3QaKS50aWNrZXR0YWxseS52MS5VbmxpbmtVc2VyQWNjb3VudFJlc3BvbnNlQihaJmdpdGh1Yi5jb20vZHVjYnQvdHQtZ28vZ2VuL3Byb3RvL3YxO3YxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * User identified from auth context
 *
 * @generated from message tickettally.v1.GenerateUserLinkTokenRequest
 */
export type GenerateUserLinkTokenRequest = Message<"tickettally.v1.GenerateUserLinkTokenRequest"> & {
};

/**
 * Describes the message tickettally.v1.GenerateUserLinkTokenRequest.
 * Use `create(GenerateUserLinkTokenRequestSchema)` to create a new message.
 */
export const GenerateUserLinkTokenRequestSchema: GenMessage<GenerateUserLinkTokenRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_telegram, 0);

/**
 * @generated from message tickettally.v1.GenerateUserLinkTokenResponse
 */
export type GenerateUserLinkTokenResponse = Message<"tickettally.v1.GenerateUserLinkTokenResponse"> & {
  /**
   * e.g., "/link_user abc123xyz"
   *
   * @generated from field: string command = 1;
   */
  command: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message tickettally.v1.GenerateUserLinkTokenResponse.
 * Use `create(GenerateUserLinkTokenResponseSchema)` to create a new message.
 */
export const GenerateUserLinkTokenResponseSchema: GenMessage<GenerateUserLinkTokenResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_telegram, 1);

/**
 * User identified from auth context
 *
 * @generated from message tickettally.v1.GetUserTelegramStatusRequest
 */
export type GetUserTelegramStatusRequest = Message<"tickettally.v1.GetUserTelegramStatusRequest"> & {
};

/**
 * Describes the message tickettally.v1.GetUserTelegramStatusRequest.
 * Use `create(GetUserTelegramStatusRequestSchema)` to create a new message.
 */
export const GetUserTelegramStatusRequestSchema: GenMessage<GetUserTelegramStatusRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_telegram, 2);

/**
 * @generated from message tickettally.v1.GetUserTelegramStatusResponse
 */
export type GetUserTelegramStatusResponse = Message<"tickettally.v1.GetUserTelegramStatusResponse"> & {
  /**
   * @generated from field: bool is_linked = 1;
   */
  isLinked: boolean;

  /**
   * @generated from field: string telegram_username = 2;
   */
  telegramUsername: string;

  /**
   * @generated from field: int64 telegram_id = 3;
   */
  telegramId: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp linked_at = 4;
   */
  linkedAt?: Timestamp;
};

/**
 * Describes the message tickettally.v1.GetUserTelegramStatusResponse.
 * Use `create(GetUserTelegramStatusResponseSchema)` to create a new message.
 */
export const GetUserTelegramStatusResponseSchema: GenMessage<GetUserTelegramStatusResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_telegram, 3);

/**
 * User identified from auth context
 *
 * @generated from message tickettally.v1.UnlinkUserAccountRequest
 */
export type UnlinkUserAccountRequest = Message<"tickettally.v1.UnlinkUserAccountRequest"> & {
};

/**
 * Describes the message tickettally.v1.UnlinkUserAccountRequest.
 * Use `create(UnlinkUserAccountRequestSchema)` to create a new message.
 */
export const UnlinkUserAccountRequestSchema: GenMessage<UnlinkUserAccountRequest> = /*@__PURE__*/
  messageDesc(file_v1_user_telegram, 4);

/**
 * @generated from message tickettally.v1.UnlinkUserAccountResponse
 */
export type UnlinkUserAccountResponse = Message<"tickettally.v1.UnlinkUserAccountResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message tickettally.v1.UnlinkUserAccountResponse.
 * Use `create(UnlinkUserAccountResponseSchema)` to create a new message.
 */
export const UnlinkUserAccountResponseSchema: GenMessage<UnlinkUserAccountResponse> = /*@__PURE__*/
  messageDesc(file_v1_user_telegram, 5);

/**
 * @generated from service tickettally.v1.UserTelegramService
 */
export const UserTelegramService: GenService<{
  /**
   * Generate link token for user (returns /link_user command)
   *
   * @generated from rpc tickettally.v1.UserTelegramService.GenerateUserLinkToken
   */
  generateUserLinkToken: {
    methodKind: "unary";
    input: typeof GenerateUserLinkTokenRequestSchema;
    output: typeof GenerateUserLinkTokenResponseSchema;
  },
  /**
   * Get user's Telegram link status
   *
   * @generated from rpc tickettally.v1.UserTelegramService.GetUserTelegramStatus
   */
  getUserTelegramStatus: {
    methodKind: "unary";
    input: typeof GetUserTelegramStatusRequestSchema;
    output: typeof GetUserTelegramStatusResponseSchema;
  },
  /**
   * Unlink user's Telegram account
   *
   * @generated from rpc tickettally.v1.UserTelegramService.UnlinkUserAccount
   */
  unlinkUserAccount: {
    methodKind: "unary";
    input: typeof UnlinkUserAccountRequestSchema;
    output: typeof UnlinkUserAccountResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_user_telegram, 0);

